// Firebase connection
import Rebase from 're-base';

const base = Rebase.createClass( {
	apiKey: "AIzaSyBrmiY0ix74y_7pXvVSO59UeCMwieML8a8",
	authDomain: "catch-of-the-day-fae3e.firebaseapp.com",
	databaseURL: "https://catch-of-the-day-fae3e.firebaseio.com",
} );

export default base;



/** WEBPACK FOOTER **
 ** ./src/base.js
 **/